import { render, staticRenderFns } from "./cgv.vue?vue&type=template&id=56a0c2b2"
import script from "./cgv.vue?vue&type=script&lang=ts"
export * from "./cgv.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a0c2b2')) {
      api.createRecord('56a0c2b2', component.options)
    } else {
      api.reload('56a0c2b2', component.options)
    }
    module.hot.accept("./cgv.vue?vue&type=template&id=56a0c2b2", function () {
      api.rerender('56a0c2b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/cgv.vue"
export default component.exports